import type React from "react";
import { Sheet, SheetContent } from "../core/sheet.core";
import { useHandleNavigate } from "../../../utils/utils";
import { useSearchParams } from "react-router-dom";

interface AppProps {
  navigatePath: string;
  children: React.ReactNode;
  className?: string;
}

export const Slider: React.FunctionComponent<AppProps> = ({
  navigatePath,
  children,
  className,
}) => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");

  let path = navigatePath;

  if (status && path.includes("manage")) {
    path += `?status=${status}`;
  }

  const { handleNavigate, open } = useHandleNavigate(path);

  return (
    <Sheet defaultOpen={open} onOpenChange={handleNavigate}>
      <SheetContent
        className={`flex flex-col py-0 bg-white justify-between border-border border-l w-full max-w-screen-sm h-full font-bold text-primary overflow-y-scroll ${className}`}
      >
        {children}
      </SheetContent>
    </Sheet>
  );
};
